import React from 'react';
import { core_apimessages_Country as Country } from '../rql';

interface Props {
  country: Country;
}

export default function ListingShopCountryNudge({ country }: Props) {
  return (
    <span className="listing-shop-country-nudge">
      <span className={`flag-icon flag-icon-${country.countryCode.toLowerCase()}`} />
      {country.name}
    </span>
  );
}
